export const db = {
  url: "https://serwis.erpatech.pl",
  token: "Token 4695f36f199000bff9859143974a66a20133753f",
};

// export const db = {
//   url: "http://10.3.0.207:8000",
//   token: "Token 7555694e17a732150112477f40ccc7a4aef6a763",
// };
